import api from '@/api';
import { API_BASE_URL } from '../../..';
import { QuestCommissionByFinancialRequest } from '../../../Reports/CommissionByFinancial/CommissionByFinancial.types';

const CONTROLLER_URL = `${API_BASE_URL}/Csv`;

export async function getQuestReportCsvCommisionByFinancial(
  params: QuestCommissionByFinancialRequest,
) {
  const result = (await api.getReport(
    `${CONTROLLER_URL}/CommissionByFinancial`,
    params,
  )) as unknown;

  return result as BlobPart;
}
